import { appServiceApi } from "../../app/appServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType, PatchQueryArgsType } from "../../types";
import {
  GetApprovalMatrixDetailsResponseType,
  GetApprovalMatrixListResponseType,
  GetApprovalMatrixParams,
} from "../../types/approvalMatrix";

export const approvalMatrixApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalMatrixList: builder.query<
      GetApprovalMatrixListResponseType,
      GetQueryArgsType<GetApprovalMatrixParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getApprovalMatrixList,
        ...queryArgs,
      }),
      providesTags: ["GetApprovalMatrix"],
    }),

    getApprovalMatrixDetails: builder.query<
      GetApprovalMatrixDetailsResponseType,
      { id: string; level: string }
    >({
      query: ({ id, level }) => ({
        url: `${API_URL.getApprovalMatrixDetails}/${id}?level=${level}`,
      }),
      providesTags: (_, __, id) => [
        {
          type: "GetApprovalMatrixDetails",
          id: id.id,
        },
      ],
    }),

    addApprovalMatrix: builder.mutation({
      query: (data) => ({
        url: API_URL.addApprovalMatrix,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetApprovalMatrix"];
        return [];
      },
    }),
    updateApprovalMatrix: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateApprovalMatrixStatus}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetApprovalMatrix",
            {
              type: "GetApprovalMatrixDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateApprovalMatrixStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateApprovalMatrixStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetApprovalMatrix",
            {
              type: "GetApprovalMatrixDetails",
              id,
            },
          ];
        return [];
      },
    }),
  }),
});

export const {
  useGetApprovalMatrixListQuery,
  useGetApprovalMatrixDetailsQuery,
  useAddApprovalMatrixMutation,
  useUpdateApprovalMatrixMutation,
  useUpdateApprovalMatrixStatusMutation,
} = approvalMatrixApi;
